import { CampoModel } from "./campoModel";

export class SuperCampo extends CampoModel<string> {
  // controlType = 'ng2-select'; //Passo nel modello
  options: { key: string; value: string }[] = [];
  type: string;
  operator?: any = {}
  extra?: any = {}

  constructor(options: {} = {}) {
    super(options);
    this.options = options["options"] || [];
    this.type = options["type"] || "";
    this.operator = options["operator"] || null;
    this.extra = options["extra"] || null;
  }
}
